import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import Logo from '../components/Logo';
import Footer from '../components/Footer';

const POST_LOGIN_KEY = 'summaros:post-login-next';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const next = searchParams.get('next');
    if (next) {
      try { sessionStorage.setItem(POST_LOGIN_KEY, next); } catch { /* ignore */ }
    }
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <SEO
        title="Sign in to Summaros"
        description="Sign in with Google to build your Life Profile on Summaros."
        path="/login"
        noindex
      />
      <header className="border-b border-line bg-cream">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="inline-flex" data-testid="login-brand">
            <Logo />
          </Link>
          <button
            onClick={() => navigate('/')}
            className="text-sm text-ink-muted hover:text-forest transition-colors inline-flex items-center gap-1.5"
            data-testid="login-back"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            Back
          </button>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-md w-full animate-fade-up">
          <div className="text-center mb-10">
            <p className="eyebrow mb-5">Welcome</p>
            <h1
              className="display-serif text-4xl sm:text-5xl mb-4 text-forest"
              data-testid="login-title"
              style={{ fontVariationSettings: "'opsz' 96, 'SOFT' 50, 'wght' 360" }}
            >
              Let's figure you out.
            </h1>
            <p className="text-ink-muted text-[16px]">
              Sign in so your Life Profile stays with you, on any device.
            </p>
          </div>

          <div className="bg-cream-soft border border-line rounded-2xl p-8">
            <button
              onClick={handleGoogleLogin}
              className="btn-primary w-full"
              data-testid="google-login-btn"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
              Continue with Google
            </button>

            <p className="mt-6 text-xs text-ink-faint text-center leading-relaxed">
              We only use your email and name.
              Your Life Profile is private by default.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Login;
